import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JwtHelper } from 'angular2-jwt';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment.dev';
import { ResetService } from 'src/app/service/widetreset.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
  animations: [
    trigger('showInfo', [
      state('1', style({ transform: 'rotate(180deg)' })),
      state('0', style({ transform: 'rotate(0deg)' })),
      transition('1 => 0', animate('400ms')),
      transition('0 => 1', animate('400ms'))
    ])
  ]
})
export class HeaderComponent implements OnInit {

  old_password: any;
  new_password: any;
  confirm_password: any;
  submittedPassword: boolean = false
  passwordMatch: boolean = false
  passerror: boolean = false;
  agencys: any = {};
  get validationPass() { return this.PasswordForm.controls; }
  newpwd: string = ''
  oldpwd: string = ''
  newpwd1: string = ''
  PasswordForm: FormGroup;
  public showHorizontalMenu: boolean = true;
  public showInfoContent: boolean = false;
  public settings: Settings;
  public menuItems: Array<any>;
  public onDestroy$: Subject<void> = new Subject<void>();
  JwtHelper: JwtHelper = new JwtHelper();
  decodedToken: any;
   public environment
  constructor(private resetService: ResetService,private formBuilder: FormBuilder, public global: GlobalComponent, private router: Router,
    public http: HttpClient, private toastservice: ToastrService, public appSettings: AppSettings, public menuService: MenuService
  ,public update:SwUpdate) {
    this.settings = this.appSettings.settings;
    this.menuItems = this.menuService.getHorizontalMenuItems();
    
    
    this.decodedToken = this.JwtHelper.decodeToken(this.global.authtoken);

    this.global.globalAgencyId = this.decodedToken.AGENCYID
    this.global.LoginEntityType = this.decodedToken.LOGINENTITYTYPE
    this.global.loginusername = this.decodedToken.LOGINUSERNAME
  }
public env
  ngOnInit() {
    this.env = environment
    this.global.globalAgencyDropDown = JSON.parse(localStorage.getItem("CFSS_agencyNames"));
    if (this.global.selectedAgencyDropdown != null &&
      this.global.selectedAgencyDropdown != "" && this.global.selectedAgencyDropdown != undefined &&
      this.global.selectedAgencyDropdown != "00000000-0000-0000-0000-000000000000" &&
      this.global.selectedAgencyDropdown.length != 0) {
      this.global.globalAgencyId = this.global.selectedAgencyDropdown
    }

    let OnboardUserType = localStorage.getItem("CFSS_OnboardLoginType");
    let UserType = localStorage.getItem("agencyLogin");

    if (window.innerWidth <= 768)
      this.showHorizontalMenu = false;
    this.updatePasswordForm()
  }

  triggerReset() {
    // Toggle showSideChat
    this.settings.theme.showSideChat = !this.settings.theme.showSideChat;
    this.global.isMaximized = false;
    
    // Trigger reset function in AgentComponent
    this.resetService.triggerReset();
  }
  refreshAgencyPage() {
    this.global.globalAgencyId = parseInt(this.global.globalAgencyDropDown || 0);
    this.global.globalAgencyId = this.global.selectedAgencyDropdown
    this.global.refreshAgencyDetails(this.global.selectedAgencyDropdown);
    this.global.selectedLocationDropdown = null;
    this.global.LocationName = null;
    this.global.selectedLocationDropdown = null;
    this.global.getAgencySetting();
    localStorage.removeItem("CFSS_location");
    if (this.global.selectedAgencyDropdown == null || this.global.selectedAgencyDropdown == undefined
      || this.global.selectedAgencyDropdown == '') {
      this.global.globalAgencyId = "00000000-0000-0000-0000-000000000000";
      this.global.globalLocationList = [];
    }
    else {
      this.global.GetLocationDropDown();
    }
  }

  refreshLocationPage(data) {
    this.global.refreshLocationDetails(data);
  }
  public closeSubMenus() {
    let menu = document.querySelector("#menu0");
    if (menu) {
      for (let i = 0; i < menu.children.length; i++) {
        let child = menu.children[i].children[1];
        if (child) {
          if (child.classList.contains('show')) {
            child.classList.remove('show');
            menu.children[i].children[0].classList.add('collapSsed');
          }
        }
      }
    }
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    if (window.innerWidth <= 768) {
      this.showHorizontalMenu = false;
    }
    else {
      this.showHorizontalMenu = true;
    }
  }
  logout() {
    this.router.navigateByUrl("/login");
  }

  // .........................................passvalid.........................................
  passvalid(event) {
    let str = event.target.value;
    let res;

    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.passerror = false;
    }
    else {
      this.passerror = true;
    }

  }

  // ............................................change password................................................................//
  updatePasswordForm() {
    this.PasswordForm = this.formBuilder.group({
      old_password: ['', Validators.required],
      newPass: ['', [Validators.required, Validators.minLength(6)]],
      confirmPass: ['', Validators.required],
    })

  }
  // ......................................................onboardclient...................................................................................
  UpdatePassword() {
    if (this.newpwd === this.newpwd1) {
      this.passwordMatch = false;
    } else {
      this.passwordMatch = true;
    }

    if (this.PasswordForm.invalid || this.passwordMatch == true) {
      if (this.PasswordForm.invalid) {
        this.submittedPassword = true;
      }
      return;
    }
    this.passwordMatch = false

    let OnboardUserType = localStorage.getItem("CFSS_OnboardLoginType");

    if (OnboardUserType == "CLIENT") {

      this.ChangePasswordclient(this.oldpwd, this.newpwd1);

    }
    else if (OnboardUserType == "EMPLOYEE") {
      this.ChangePasswordEmployee(this.oldpwd, this.newpwd1);
    }

    else {
      this.ChangeAgencyPassword(this.oldpwd, this.newpwd1);
    }
  }

  reset() {
    this.PasswordForm.reset()
  }

  clear_pass() {
    this.PasswordForm.reset()
    this.passwordMatch = false;
    this.submittedPassword = false;
  }
  //................................................ ChangePasswordclient................................................
  ChangePasswordclient(old_password, newPass) {
    let params = new URLSearchParams();
    let url = "api/Client/changePassword?";

    // params.append("LoginuserId", this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toastservice.success("Password Changed Successfully")
        setTimeout(() => {

          this.toastservice.clear()

        }, 8000);
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toastservice.error(err.error);
    });

  }

  // ........................................................employee.................................................................
  ChangePasswordEmployee(old_password, newPass) {
    let params = new URLSearchParams();
    let url1 = "api/Employee/changePassword?";

    //params.append("LoginuserId",this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url1 + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toastservice.success("Password Changed Successfully")
        setTimeout(() => {

          this.toastservice.clear()

        }, 8000);
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toastservice.error(err.error);
    });

  }
  // .........................................................agencyuser.......................................................................

  ChangeAgencyPassword(old_password, newPass) {
    let params = new URLSearchParams();
    let url = "api/User/changePassword?";

    //params.append("LoginuserId",this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toastservice.success("Password Changed Successfully")
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toastservice.error(err.error);
    });

  }


  userlocation: any;
  getLocation() {
    if (this.global.agencyCode != 'SUPERADMIN' && this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let url = "api/User/GetLocationDropDownForUSER?";

      return this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.userlocation = data;
        this.global.globalLocationList = this.userlocation;
      })
    }


  }

  activateToCurrentVersion() {
    this.update.activateUpdate().then(() => window.location.reload());
    this.update.activated.subscribe((event) => {

    });
  }


}
